var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_vm._v(" 员工调薪 ")])}
var staticRenderFns = []

export { render, staticRenderFns }